'use client';
import React from 'react';
import { Box } from '@chakra-ui/react';

interface DiscountBadgeProps {
  originalPrice: number;
  salePrice?: number;
}

export const DiscountBadge = ({ originalPrice, salePrice }: DiscountBadgeProps) => {
  if (!salePrice) {
    return null;
  }

  // Calculate discount percentage
  const discountPercentage = Math.round(((originalPrice - salePrice) / originalPrice) * 100);

  if (discountPercentage <= 0) {
    return null;
  }

  return (
    <Box
      backgroundColor="green.80"
      borderRadius="8px 0px 8px 0px"
      color="common.100"
      textStyle="body3"
      fontWeight="medium"
      left="0"
      padding="4px 6px"
      position="absolute"
      top="0"
      zIndex={1}
    >
      {discountPercentage}% off
    </Box>
  );
};
